<template>

  <div id="quotation-delivery" class="sixteen wide column">

    <div class="ui segment" :class="{ loading }">
      <h4 class="ui dividing header">Entrega</h4>
      <button class="ui mini basic button m-b-10" :class="{ disabled: !canUseBillingAddress }" @click="onUseBillingAddress()">
        <i class="plus blue icon"></i> Usar endereço de faturamento
      </button>
      <form class="ui form">
        <div class="fields">
          <div class="three wide search field">
            <label class="form-label">CEP <span class="red text">*</span></label>
            <div class="ui action input">
              <the-mask type="tel" mask="#####-###" v-model="delZipCode" @blur.native="loadAddress()" />
              <button type="button" class="ui basic icon button" @click="$refs.addressPicker.show()">
                <i class="search plus black icon"></i>
              </button>
            </div>  
          </div>
          <div class="eight wide field">
            <label class="form-label">Endereço</label>
            <input type="text" readonly="readonly" :value="delAddress">
          </div>                    
          <div class="two wide field">
            <label class="form-label">Número</label>
            <input type="text" v-model="delNumber" @blur="onChange()" maxlength="20">
          </div>              
          <div class="three wide field">
            <label class="form-label">Complemento</label>
            <input type="text" v-model="delComplement" @blur="onChange()" maxlength="30">
          </div>                    
        </div>
        <div class="fields">
          <div class="five wide field">
            <label class="form-label">Município <span class="red text">*</span></label>
            <input type="text" readonly="readonly" :value="delCity">
          </div>
          <div class="two wide field">
            <label class="form-label">Estado <span class="red text">*</span></label>
            <input type="text" readonly="readonly" :value="delState">  
          </div>
          <div class="three wide field" :class="{ disabled: productInputVisible }">
            <label class="form-label">Frete <span class="red text">*</span></label>
            <select id="select-freight" class="ui fluid dropdown" v-model="freight">
              <option value="">Selecione...</option>
              <option value="C">CIF</option>
              <option value="F">FOB</option>
            </select>
          </div>          
          <div class="three wide field">
            <label class="form-label">Tipo de Entrega <span class="red text">*</span></label>
            <select id="select-delivery-type" class="ui fluid dropdown" v-model="deliveryType">
              <option value="">Selecione...</option>
              <option value="1">Imediata</option>
              <option value="2">Programada</option>
            </select>
          </div>
          <div class="three wide field">
            <label>Fat. a partir de</label>
            <div v-show="deliveryType != '1'" id="billing-date" class="ui calendar">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input class="date">
              </div>
            </div>
            <div v-show="deliveryType == '1'" class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" :value="$formatDate(billingDate)" readonly="readonly">
            </div>
          </div>
        </div>
      </form>
    </div>

    <address-picker ref="addressPicker" @onSelect="onSelectAddress" />

  </div>    

</template>

<script>

  import { TheMask } from "vue-the-mask"
  import { cleanSpecialChars, Calendar, moment } from "@/utils"
  import ZipCodeService from "@/services/zip-code-service"
  import AddressPicker from "@/components/address-picker.vue"  

  export default {
    
    data() {
      return {
        loading: false,
        mounting: true,
        delZipCode: "",
        delAddress: "",
        delNumber: "",
        delComplement: "",
        delCity: "",
        delState: "",
        freight: "",
        deliveryType: "",
        billingDate: null,
      }
    },

    components: {
      TheMask,
      AddressPicker,
    },

    props: ["quotation", "isCreating", "isUpdating", "productInputVisible"],

    watch: {

      "freight" () {
        
        if (this.loading || this.mounting)
          return

        this.onChange()
      },

      "deliveryType" () {

        if (this.loading || this.mounting)
          return

        if (this.deliveryType == "1") {

          this.billingDate = new Date()

        } else if (this.deliveryType == "2") {

          this.billingDate = null

          $("#billing-date").calendar("set date", null)
        }
      },

      "billingDate" () {

        if (this.loading || this.mounting)
          return

        this.onChange()
      },
    },

    created() {      

      if (this.isUpdating) {
        this.delZipCode = this.quotation.delZipCode
        this.delAddress = this.quotation.delAddress
        this.delNumber = this.quotation.delNumber
        this.delComplement = this.quotation.delComplement
        this.delCity = this.quotation.delCity
        this.delState = this.quotation.delState
        this.freight = this.quotation.freight
        this.deliveryType = this.quotation.deliveryType
        this.billingDate = this.quotation.billingDate
      }      
    },

    mounted() {

      $("#select-freight").dropdown()
      $("#select-delivery-type").dropdown()

      Calendar.init("#billing-date", {
        onChange: (date) => this.billingDate = date,
      })      

      if (this.isUpdating) {
        $("#select-freight").dropdown("set selected", this.freight)
        $("#select-delivery-type").dropdown("set selected", this.deliveryType)
        $("#billing-date").calendar("set date", moment(this.billingDate).toDate())
      }

      setTimeout(() => this.mounting = false, 800)
    },

    computed: {

      canUseBillingAddress() {
        return (this.quotation && this.quotation.customer && this.quotation.customer.code)
      },
    },

    methods: {

      onChange() {
        this.$emit("onChange", {
          delZipCode: this.delZipCode,
          delAddress: cleanSpecialChars(this.delAddress),
          delNumber: cleanSpecialChars(this.delNumber),
          delComplement: cleanSpecialChars(this.delComplement),
          delCity: cleanSpecialChars(this.delCity),
          delState: this.delState,
          freight: this.freight,
          deliveryType: this.deliveryType,
          billingDate: this.billingDate,
        })
      },

      onSelectAddress(address) {

        this.delZipCode = address.zipCode
        this.delAddress = address.address
        this.delCity = address.city
        this.delState = address.state        
        this.delNumber = ""
        this.delComplement = ""

        this.onChange()
      },

      clearAddress() {

        this.delZipCode = ""
        this.delAddress = ""
        this.delCity = ""
        this.delState = ""
        this.delNumber = ""
        this.delComplement = ""

        this.onChange()
      },

      async loadAddress() {

        if (this.delZipCode.trim().length < 8) {
          this.clearAddress()          
          return
        }  

        this.loading = true

        try {

          const address = await ZipCodeService.getAddress(this.delZipCode)    

          this.onSelectAddress(address)
          
        } catch (error) {

          this.clearAddress()
          this.$errorHandler(error)
          
        } finally {

          this.loading = false
        } 
      },

      onUseBillingAddress() {

        const { zipCode, address, city, state } = this.quotation.customer

        const data = {
          zipCode: zipCode ? zipCode.replace("-", "") : "",
          address,
          city,
          state,
        }        

        this.onSelectAddress(data)
      },
    },
  }

</script>

